var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorToolbarTextTypeA1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754:488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 19H15L10 5H8L3 19H5L6.43 15H11.57L13 19ZM7.14 13L9 7.8L10.86 13H7.14Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7199 9V19.16H18.5599V11H18.4999L16.1699 12.46V10.58L18.6899 9H20.7199Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754:488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.72,
    height: 14.16,
    fill: "white",
    transform: "translate(3 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorToolbarTextTypeA1);
export default __webpack_public_path__ + "static/media/editor_toolbar_text_type_a1.fbdbaa74743fe1798f3e2359a8c54312.svg";
export { ForwardRef as ReactComponent };